import useFetchIncludedFeaturesQuery from '@projects/queries/useFetchIncludedFeaturesQuery';
import { getPricingPlanWithFeature } from 'src/selectors/pricingPlans';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchPricingPlans } from 'src/actions/pricing';

const useFeatureIsAvailableForProject = ( projectID: number, feature: string ) => {
	const dispatch = useDispatch();

	const { data: includedFeatures, isLoading } = useFetchIncludedFeaturesQuery( projectID );
	const available = Array.isArray( includedFeatures ) && includedFeatures.includes( feature );

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-expect-error
	const planWithFeature = useSelector( state => getPricingPlanWithFeature( state, { feature } ) );
	useEffect( () => { dispatch( fetchPricingPlans() ); }, [ dispatch ] );

	return { available, isLoading, planWithFeature };
}

export default useFeatureIsAvailableForProject;
